import React from "react";
import Button from "../../../../component/button/Button";
import { useSelector } from "react-redux";
import Image from "../../../../component/image/Image";
import LinkedIn from "../../../../assets/images/linkedIn-white.png";
import FaceBook from "../../../../assets/images/facebook-white.png";


const ShareJob = (props: any) => {
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });

    const { navigateToJob, navigateToJobAlerts, cliendConfig, routeParams, location} = props;

    const openLinkedinUrl = () => {
        window.open(cliendConfig?.data?.data?.clientSettings?.linkedinUrl, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
    };
    const openFaceBookUrl = () => {
        window.open(cliendConfig?.data?.data?.clientSettings?.facebookUrl, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
    };

    const openTwitterUrl = () => {
        window.open(cliendConfig?.data?.data?.clientSettings?.twitterUrl, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
    };

    return (
        <>
            <div className="opt3-sm">
                <>
                    {/* <h2 className="job-view-text">Follow us to stay updated!</h2> */}
                    <div className="sm-list">
                        {(cliendConfig?.data?.data?.clientSettings?.linkedinUrl !== "" && cliendConfig?.data?.data?.clientSettings?.linkedinUrl !== null) ? (
                            <Button onClick={() => openLinkedinUrl()} clasName="sm-linkedin-icon" label={
                                <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.0503 1.94922C3.20596 1.94922 2.52148 2.63369 2.52148 3.47804C2.52148 4.32238 3.20596 5.00686 4.0503 5.00686C4.89465 5.00686 5.57912 4.32238 5.57912 3.47804C5.57912 2.63369 4.89465 1.94922 4.0503 1.94922Z" fill="#3A3E54"/>
                                <path d="M2.61141 6.26589C2.56175 6.26589 2.52148 6.30615 2.52148 6.35582V15.7086C2.52148 15.7583 2.56175 15.7985 2.61141 15.7985H5.48919C5.53886 15.7985 5.57912 15.7583 5.57912 15.7086V6.35582C5.57912 6.30615 5.53886 6.26589 5.48919 6.26589H2.61141Z" fill="#3A3E54"/>
                                <path d="M7.2878 6.26589C7.23814 6.26589 7.19787 6.30615 7.19787 6.35582V15.7086C7.19787 15.7583 7.23814 15.7985 7.2878 15.7985H10.1656C10.2152 15.7985 10.2555 15.7583 10.2555 15.7086V10.6725C10.2555 10.3147 10.3976 9.9716 10.6506 9.71863C10.9036 9.46565 11.2467 9.32352 11.6045 9.32352C11.9622 9.32352 12.3053 9.46565 12.5583 9.71863C12.8113 9.9716 12.9534 10.3147 12.9534 10.6725V15.7086C12.9534 15.7583 12.9937 15.7985 13.0434 15.7985H15.9211C15.9708 15.7985 16.0111 15.7583 16.0111 15.7086V9.50716C16.0111 7.76125 14.4926 6.39538 12.7555 6.5533C12.2197 6.60201 11.6901 6.73519 11.1954 6.94716L10.2555 7.34999V6.35582C10.2555 6.30615 10.2152 6.26589 10.1656 6.26589H7.2878Z" fill="#3A3E54"/>
                                </svg>
                                </>
                            } />
                        ) : ""}

                        {(cliendConfig?.data?.data?.clientSettings?.facebookUrl !== "" && cliendConfig?.data?.data?.clientSettings?.facebookUrl !== null) ? (
                            <Button onClick={() => openFaceBookUrl()} clasName="sm-fb-icon" label={
                                <>
                                    <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_8577_25268" maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="17">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.949219 0.319336H9.1702V16.1471H0.949219V0.319336Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_8577_25268)">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.37961 16.1472V8.92838H0.949219V6.11509H3.37961V4.03854C3.37961 1.62687 4.84986 0.319336 6.99873 0.319336C8.02797 0.319336 8.91451 0.394236 9.1702 0.430395V2.94602H7.68187C6.51252 2.94602 6.28588 3.50132 6.28588 4.31812V6.11509H9.07141L8.70917 8.92838H6.28588V16.1472H3.37961Z" fill="#3A3E54"/>
                                        </g>
                                    </svg>

                                </>
                            } />
                        ) : ""}

                        {(cliendConfig?.data?.data?.clientSettings?.twitterUrl !== "" && cliendConfig?.data?.data?.clientSettings?.twitterUrl !== null) ? (
                            <Button onClick={() => openTwitterUrl()} clasName="sm-twitter-icon" label={
                                <>
                                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.46581 8.03374L5.95368 7.28114L1.97648 1.43737H3.66228L6.9054 6.15912L7.41928 6.90747L11.4083 12.7156H9.65225L6.46581 8.03374ZM7.96527 6.26242L7.45183 5.51481L4.08973 0.619517H0.433594L5.40649 7.9263L5.9191 8.67955L9.22239 13.5332H12.9592L7.96527 6.26242Z" fill="#3A3E54"/>
                                    <path d="M5.95363 7.28114L6.46576 8.03374L5.91905 8.67955L1.81006 13.5332H0.650391L5.40644 7.9263L5.95363 7.28114Z" fill="#3A3E54"/>
                                    <path d="M12.7433 0.619274L7.96612 6.26218L7.42013 6.90723L6.90625 6.15888L7.45268 5.51457L11.605 0.619274H12.7433Z" fill="#3A3E54"/>
                                    </svg>
                                </>
                            } />
                        ) : ""}
                    </div>
                </>
            </div>
        </>
    );
};

export default ShareJob;